module.exports = __webpack_public_path__ + "img/58200.8e1452ff.jpg";